<template>
  <footer id="footer">
    <div class="footer-item">
      <div class="footer-item__list">
        <p>中國信託證券投資信託股份有限公司</p>
        <p>
          <span>台北總公司：台北市南港區經貿二路188號12樓 / 02-2652-6688</span>
          <span>台中分公司：台中市西區忠明南路499號9樓之1 / 04-2372-5199</span>
        </p>
      </div>
      <div class="footer-item__list">©CTBCINVESTMENTS</div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {},
  data: () => {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
#footer {
  width: 100%;
  height: 113px;
  background-color: #0d7c7c;
  font-weight: 400;
  color: #fff;
  @include tablet {
    height: vwM(316);
  }
  .footer-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;

    @include tabletX {
      width: 100%;
      max-width: vwX(1400);
      padding: 0 vwX(10);
    }
    @include tablet {
      display: block;
      padding: vwM(55) 0 0 vwM(60);
    }
  }
  .footer-item__list {
    &:nth-child(1) {
      font-size: 20px;
      line-height: lineHeight(20, 26);
      letter-spacing: letterSpacing(50, 20px);
      margin-top: 30px;
      @include tablet {
        font-size: vwM(27);
        line-height: lineHeight(27, 36);
        letter-spacing: letterSpacing(50, vwM(27));
        margin-top: 0;
      }
      p:nth-child(2) {
        font-size: 15px;
        letter-spacing: letterSpacing(50, 15px);
        margin-top: 7px;
        @include tablet {
          font-size: vwM(20);
          letter-spacing: letterSpacing(50, vwM(20));
          margin-top: vwM(7);
        }
        span {
          @include tablet {
            display: block;
          }
          &:nth-child(1) {
            border-right: 1px solid #fff;
            padding-right: 10px;
            @include tablet {
              border-right: unset;
              padding-right: 0;
            }
          }
          &:nth-child(2) {
            padding-left: 10px;
            @include tablet {
              padding-left: 0;
              margin-top: vwM(9);
            }
          }
        }
      }
    }
    &:nth-child(2) {
      font-size: 12px;
      letter-spacing: letterSpacing(50, 12px);
      margin-top: 67px;
      @include tablet {
        font-size: vwM(17);
        letter-spacing: letterSpacing(50, vwM(17));
        margin-top: vwM(50);
      }
    }
  }
}
</style>
